import * as React from 'react'

import { Box, Icon, Text, Touchable } from '@factorialco/deprecated-design-system'

export interface SectionItem {
  label: string
  value:
    | 'basic-info'
    | 'description'
    | 'application-form'
    | 'hiring-pipeline'
    | 'hiring-team'
    | 'internal-evaluation-forms'
    | 'smart-actions'
  icon: React.ComponentProps<typeof Icon.Medium>['icon']
  disabled?: boolean
}

interface SectionSelectorProps {
  selected: boolean | undefined
  onChange: (label: string) => void
}

export const SectionSelector = ({
  label,
  value,
  icon,
  selected = false,
  disabled = false,
  onChange,
}: React.PropsWithChildren<SectionSelectorProps & SectionItem>) => {
  return (
    <Touchable
      onClick={() => onChange(value)}
      buttonBorderRadius="abs016"
      aria-pressed={selected}
      disabled={disabled}
    >
      <Box
        width="full"
        flexDirection="row"
        justifyContent="spaceBetween"
        paddingX="s16"
        paddingY="s12"
        alignItems="center"
        background={selected ? 'grey200' : 'grey000White'}
        borderRadius={{ all: 'abs016' }}
        gap="s8"
      >
        <Box flexGrow flexDirection="row" gap="s8" textAlign="left">
          <Icon.Medium icon={icon} color={disabled ? 'grey600' : 'grey800'} />
          <Text.Normal size="300" weight="semibold" color={disabled ? 'grey600' : 'grey1000'}>
            {label}
          </Text.Normal>
        </Box>
        <Icon.Medium icon="chevron-right" color={selected ? 'grey800' : 'grey000White'} />
      </Box>
    </Touchable>
  )
}
